<template>
  <div class="ui form">
    <div class="fields">
      <div class="seven wide field">
        <label for="">{{ $t("course") }}</label>
        <div class="ui search" ref="course_search">
          <input
            class="prompt"
            type="text"
            :placeholder="$t('search course')"
          />
          <div class="results"></div>
        </div>
      </div>
      <div class="five wide field">
        <label>{{ $t("section name") }}</label>
        <input type="text" v-model="section.name" />
      </div>
      <div class="four wide field">
        <label for="">{{ $t("branch") }}</label>
        <div class="ui search selection dropdown" ref="branch_dropdown">
          <input type="hidden" name="branch" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
    </div>
    <div class="fields">
      <!-- <div class="six wide field">
        <label for="">{{ $t("career") }}</label>
        <div class="ui search selection dropdown" ref="career_dropdown">
          <input type="hidden" name="studying_time" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div> -->
      <div class="four wide field">
        <label for="">{{ $t("studying time") }}</label>
        <div class="ui search selection dropdown" ref="studying_dropdown">
          <input type="hidden" name="studying_time" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="four wide field">
        <label for="">{{ $t("day") }}</label>
        <div class="ui search selection dropdown" ref="day_dropdown">
          <input type="hidden" name="day_dropdown" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="four wide field">
        <label for="">{{ $t("schedule") }}</label>
        <div class="ui search selection dropdown" ref="schedule_dropdown">
          <input type="hidden" name="schedule_dropdown" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu">
            <!-- <div
              class="item"
              v-for="(schdl, sidx) in computed_schedules"
              :key="sidx"
              :value="schdl.name"
              :disabled="schdl.is_visible"
            >
              {{ schdl.name }} {{ schdl.is_visible }}
            </div> -->
          </div>
        </div>
      </div>
      <div class="three wide field">
        <label>{{ $t("save") }}</label>
        <div class="ui blue icon labeled button" @click="save">
          <i class="save icon"></i> {{ $t("save") }}
        </div>
      </div>
    </div>
    <div class="ui dividing header">{{ $t("students") }}</div>
    <table
      class="ui very compact striped celled table"
      v-if="section.preinscriptions"
    >
      <thead>
        <tr>
          <th>{{ $t("student") }}</th>
          <th>{{ $t("career") }}</th>
          <th>{{ $t("branch") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr v-for="(item, idx) in section.setup.students" :key="idx"> -->
        <tr v-for="(item, idx) in section.preinscriptions" :key="idx">
          <td>
            {{ item.std_student.student_id_card }} - {{ item.std_student.name }}
          </td>
          <td>{{ item.std_career.name }}</td>
          <td>{{ item.std_branch.name }}</td>
          <td>
            <div class="ui basic mini icon button" @click="remove_student(idx)">
              <i class="red trash icon"></i>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="4">
            <div
              class="ui right floated small basic labeled icon button"
              @click="add_students"
            >
              <i class="blue plus icon"></i> {{ $t("add students") }}
            </div>
          </th>
        </tr>
      </tfoot>
    </table>
    <!-- <preinscription-filter
      :section="section"
      :careers="careers"
      :branches="branches"
      :studying_times="studying_times"
      :season="season"
      @add_item="student_added"
      :course="section.crs_course.course_id"
      @add_selected="add_selected"
    /> -->
    <preinscription-filter-modal
      :section="section"
      :careers="careers"
      :branches="branches"
      :studying_times="studying_times"
      :season="season"
      @add_item="student_added"
      :course="String(section.crs_course.course_id)"
      @add_selected="add_selected"
      ref="preinscription_filter_modal"
      :users="users"
    />
  </div>
</template>

<script>
import { init_search, error_toast, local_api, success_toast } from "@/utils";
// import PreinscriptionFilter from "./PreinscriptionFilter.vue";
import PreinscriptionFilterModal from "./PreinscriptionFilterModal.vue";
import { union } from "lodash";

export default {
  components: { /* PreinscriptionFilter ,*/ PreinscriptionFilterModal },
  name: "ProfessorBasedSection",
  props: {
    careers: Array,
    branches: Array,
    studying_times: Array,
    schedules: Array,
    days: Array,
    section: Object,
    season: Object,
    professor: Object,
    users: Array,
  },
  computed: {
    // sstudents() {
    //   let vm = this;
    //   if (vm.section.setup.students) return vm.section.setup.students;
    //   else if (vm.section.crs_assignation_preinscriptions)
    //     return vm.section.crs_assignation_preinscriptions;
    //   else return [];
    // },
  },
  data() {
    return {};
  },
  mounted() {
    let vm = this;
    vm.init_search();
    vm.init_dropdowns();
    setTimeout(() => {
      if (vm.section.branch_id)
        window
          .jQuery(vm.$refs.branch_dropdown)
          .dropdown("set selected", vm.section.branch_id);

      if (vm.section.studying_time_id)
        window
          .jQuery(vm.$refs.studying_dropdown)
          .dropdown("set selected", vm.section.studying_time_id);

      if (vm.section.setup.schedule)
        window
          .jQuery(vm.$refs.schedule_dropdown)
          .dropdown("set selected", vm.section.setup.schedule);

      if (vm.section.setup.day_index)
        window
          .jQuery(vm.$refs.day_dropdown)
          .dropdown("set selected", vm.section.setup.day_index);

      if (vm.section.crs_course.name) {
        let inpt = window.jQuery(vm.$refs.course_search).find("input");
        inpt.each(function (idx, val) {
          window.jQuery(val).val(vm.section.crs_course.name);
        });
      }
    }, 1000);
  },
  methods: {
    init_search() {
      let vm = this;

      let onSearchResponse = (data) => {
        let rslt = [];
        data.map((r) => {
          rslt.push({
            title: r.name,
            course: r,
          });
        });
        return { results: rslt };
      };
      let onSearchSelect = (data) => {
        vm.section.crs_course = data.course;
        vm.section.crs_course.course_id = String(
          vm.section.crs_course.course_id,
        );
      };

      init_search(
        vm,
        vm.$refs.course_search,
        "search course",
        onSearchResponse,
        onSearchSelect,
      );
    },
    init_dropdowns() {
      let vm = this;
      // window
      //   .jQuery(vm.$refs.career_dropdown)
      //   .dropdown("setup menu", {
      //     values: vm.careers.map((c) => {
      //       return { name: c.name, value: c.career_id };
      //     }),
      //   })
      //   .dropdown({
      //     onChange(value) {
      //       vm.section.career = value;
      //     },
      //   });

      window
        .jQuery(vm.$refs.branch_dropdown)
        .dropdown("setup menu", {
          values: vm.branches.map((b) => {
            return { name: b.name, value: b.branch_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.section.branch_id = value;
          },
        });

      window
        .jQuery(vm.$refs.studying_dropdown)
        .dropdown("setup menu", {
          values: vm.studying_times.map((b) => {
            return { name: b.name, value: b.studying_time_id };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.section.studying_time_id = value;

            vm.init_schedules();
            vm.init_days();
          },
        });

      /** Lock fields depending on logged user */

      let sessionUser = vm.$session.get("user");
      let targetUser = vm.users.find((usr) => {
        return String(usr.user_id) == String(sessionUser.user_id);
      });
      if (targetUser && targetUser.std_user && targetUser.std_user.branch_id) {
        window
          .jQuery(vm.$refs.branch_dropdown)
          .dropdown("set selected", targetUser.std_user.branch_id);
        window
          .jQuery(vm.$refs.branch_dropdown)
          .closest(".field")
          .addClass("disabled");
      } else {
        window
          .jQuery(vm.$refs.branch_dropdown)
          .closest(".field")
          .removeClass("disabled");
      }

      vm.init_schedules();
      vm.init_days();
    },
    init_days() {
      let vm = this;
      let days = vm.calculate_days();
      window
        .jQuery(vm.$refs.day_dropdown)
        .dropdown("setup menu", {
          values: days.map((b) => {
            return { name: b.name, value: b.day_index };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.section.setup.day = value;
          },
        });
    },
    init_schedules() {
      let vm = this;
      let schedules = vm.calculate_schedules();
      window
        .jQuery(vm.$refs.schedule_dropdown)
        .dropdown("setup menu", {
          values: schedules.map((b) => {
            return { name: b.name, value: b.name };
          }),
        })
        .dropdown({
          onChange(value) {
            vm.section.setup.schedule = value;
          },
        });
    },
    student_added(item) {
      let vm = this;
      vm.section.preinscriptions.push(item);
      // vm.section.setup.students.push(item);
      success_toast(vm.$t("student added"));
    },
    add_selected(students) {
      let vm = this;
      // let uniqs = union(vm.section.setup.students, students);
      // this.section.setup.students = uniqs;
      let uniqs = union(vm.section.preinscriptions, students);
      this.section.preinscriptions = uniqs;
    },
    remove_student(idx) {
      // this.section.setup.students.splice(idx, 1);
      this.section.preinscriptions.splice(idx, 1);
    },
    add_students() {
      let vm = this;
      if (vm.section.crs_course.course_id)
        vm.$refs.preinscription_filter_modal.show_modal();
      else error_toast(vm.$t("select course first"));
    },
    save() {
      let vm = this;
      let data = {
        uuid: vm.section.uuid,
        name: vm.section.name,
        branch: vm.section.branch_id,
        studying_time: vm.section.studying_time_id,
        professor: vm.professor.professor_id,
        // students: vm.section.setup.students,
        preinscripions: vm.section.preinscriptions,
        attributes: vm.section.attributes,
        course: vm.section.crs_course.course_id,
        season: vm.season.season_id,
        schedule: vm.section.setup.schedule,
        day_index: vm.section.setup.day,
      };

      if (
        data.name &&
        data.professor &&
        data.preinscripions &&
        data.preinscripions.length > 0
      ) {
        data.preinscriptions = data.preinscripions.map((std) => {
          return std.preinscription_id;
        });
        delete data.students;
        local_api(vm, "post", "/course/assignation/do-save-section", data)
          .then(() => {
            success_toast(vm.$t("section saved"));
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(
          vm.$t(
            "check section name, professor and students, all are required to save section",
          ),
        );
      }
    },
    calculate_schedules() {
      let vm = this;
      return vm.schedules.filter((sc) => {
        return sc.studying_times.find((st) => {
          let isIt = String(st) == String(vm.section.studying_time_id);
          return isIt;
        });
      });
    },
    calculate_days() {
      let vm = this;
      return vm.days.filter((sc) => {
        return sc.studying_times.find((st) => {
          let isIt = String(st) == String(vm.section.studying_time_id);
          return isIt;
        });
      });
    },
  },
};
</script>
